import { render } from "./StarTemplateLockMask.vue?vue&type=template&id=5bf20cda&scoped=true&ts=true"
import script from "./StarTemplateLockMask.vue?vue&type=script&lang=ts"
export * from "./StarTemplateLockMask.vue?vue&type=script&lang=ts"

import "./StarTemplateLockMask.vue?vue&type=style&index=0&id=5bf20cda&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf20cda"]])

export default __exports__